import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import WhatsAppButton from '@/components/feature/WhatsAppButton';
import HeroSection from './components/HeroSection';
import StatsBar from './components/StatsBar';
import ProductsSection from './components/ProductsSection';
import AboutSection from './components/AboutSection';
import TechnicalCatalogSection from './components/TechnicalCatalogSection';
import TechnicalGuidesSection from './components/TechnicalGuidesSection';
import TestimonialsSection from './components/TestimonialsSection';
import PortfolioSection from './components/PortfolioSection';
import FaqSection from './components/FaqSection';
import NewsletterSection from './components/NewsletterSection';

export default function HomePage() {
  return (
    <div className="min-h-screen font-sans">
      <Header />
      <main>
        <HeroSection />
        <StatsBar />
        <ProductsSection />
        <AboutSection />
        <TechnicalCatalogSection />
        <TechnicalGuidesSection />
        <TestimonialsSection />
        <PortfolioSection />
        <FaqSection />
        <NewsletterSection />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}
